module.exports = __webpack_public_path__ + "img/banner_tjx_jchy.7224adf3.jpg";